import { render, staticRenderFns } from "./Contexto.vue?vue&type=template&id=19b2dfc1&"
import script from "./Contexto.vue?vue&type=script&lang=js&"
export * from "./Contexto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports